/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of compliance reports */
export enum ReportType {
  FinancialTransactions,
  SuspiciousActivity,
  RegulatoryCompliance,
  SecurityIncidents,
  AuditSummary,
  RiskAssessment,
  GovernanceActivity,
  DataPrivacyCompliance,
}

export type ReportTypeArgs = ReportType;

export function getReportTypeEncoder(): FixedSizeEncoder<ReportTypeArgs> {
  return getEnumEncoder(ReportType);
}

export function getReportTypeDecoder(): FixedSizeDecoder<ReportType> {
  return getEnumDecoder(ReportType);
}

export function getReportTypeCodec(): FixedSizeCodec<
  ReportTypeArgs,
  ReportType
> {
  return combineCodec(getReportTypeEncoder(), getReportTypeDecoder());
}
